// extracted by mini-css-extract-plugin
module.exports = {"contactInfo":"contactInformation_contactInfo__m_xk2"};